module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp23_7.66fd8385.png";